import { Helper } from "../core/util/helper";
import React from "react";
export default class AssignToMe extends React.Component<any, any>{
    render() {
        return (
            <div style={{ display: "flex", flexDirection: "row-reverse", paddingTop: "3px" }}>
                <label style={{ lineHeight: "1.2em", fontSize: "0.9em" }}>{Helper.getTranslation("WebSMS.ResourcePlanningScheduler.Favorite.OnlyStart")}</label>
            </div>
        );
    }
}